/**
* 基础菜单 发货单
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
<!--    <div class="breadcrumb">-->
<!--      <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--        <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--        <el-breadcrumb-item>发货单</el-breadcrumb-item>-->
<!--      </el-breadcrumb>-->
<!--    </div>-->
    <div v-if="detailData.length&&isGetData">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="detail.delivery_name=='自提'?'自提':'快递号'+detail.delivery_no" :name="detail.id" v-for="(detail,index) in detailData" :key="index">
          <div class="flex_box" style="margin-top: 15px">
            <div class="order_no item f15">
              <p class="color333">发货单号</p>
              <span class="color666">{{detail.record_code}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="item f15">
              <p class="color333">单据时间</p>
              <span class="color666">{{detail.send_time|timestampToTime}}</span>
            </div>
          </div>
          <div class="flex_box">
            <div class="item f15">
              <p class="color333">订单编号</p>
              <span class="color666">{{code}}</span>
            </div>
          </div>
          <!--列表-->
          <div class="table mt50">
            <div style="display: flex">
              <p class="title f20 color333 fontWeight mb20">已发货商品清单</p>
            </div>
            <el-table size="small" :data="detail.recordItems" highlight-current-row v-loading="loading" border
                      :summary-method="getSummaries"
                      show-summary
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column
                type="index"
                label="序号"
                width="80">
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" width="200">
              </el-table-column>
              <el-table-column prop="product_name" label="销售名称" min-width="300" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="brand_name" label="商品品牌" width="180">
              </el-table-column>
              <el-table-column prop="product_num" label="数量" width="100">
              </el-table-column>
              <el-table-column prop="average_price" label="结算单价" width="150">
                <template slot-scope="scope">
                  <div>￥{{scope.row.average_price}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="sub_total" label="小计" width="150">
                <template slot-scope="scope">
                  <div>￥{{scope.row.sub_total}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--列表-->
          <div class="table mt50">
            <p class="title f20 color333 fontWeight mb20">物流信息</p>
            <div class="flex_box lh32">
              <div class="item f15">
                <span class="color666" style="color: #409EFF;margin-right: 20px" v-if="detail.delivery_name">{{detail.delivery_name}}</span>
                <p class="color333" style="margin-right: 5px">快递单号</p>
                <span class="color666">{{detail.delivery_no}}</span>
                <img src="/static/img/edit.png" alt="" class="edit" @click="openEditDialog(detail.id,detail.delivery_no,detail.delivery_com_id,detail.delivery_name)">
              </div>
              <el-row v-if="detail.show_eorder_print_btn&&detail.delivery_name!='自提'">
                <el-button type="primary" size="small" @click="sendGood(detail.id)">重打电子面单</el-button>
              </el-row>
            </div>
            <el-table size="small" :data="detail.recordLogs" highlight-current-row v-loading="loading" border
                      element-loading-text="拼命加载中" style="width: 100%;">
              <el-table-column prop="loger" label="操作人" width="100">
              </el-table-column>
              <el-table-column prop="create_time" label="时间" width="200">
                <template slot-scope="scope">
                  <div>{{scope.row.create_time|timestampToTime}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="log" label="内容" min-width="300">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                 title="修改快递单号"
                 :visible.sync="editDialogVisible"
                 width="30%"
                 center>
        <el-form label-width="120px" :model="infoForm" :rules="infoRules" ref="deliveryForm" class="delivery">
          <el-form-item label="快递公司" prop="delivery_name">
            <el-select v-model="infoForm.delivery_name" filterable placeholder="请选择快递公司" clearable
                       @change="deliverChange(infoForm.delivery_name)">
              <el-option
                v-for="item in popularDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="delivery_no">
            <el-input size="small" v-model="infoForm.delivery_no" auto-complete="off" placeholder="请输入快递单号" clearable
                      maxLength="50"></el-input>
          </el-form-item>
        </el-form>
<!--        <el-input type="text" v-model="delivery_no" class="" placeholder="请输入快递单号" clearable></el-input>-->
        <span slot="footer" class="dialog-footer">
            <el-button @click="editDialogVisible = false">关 闭</el-button>
            <el-button type="primary" @click="sureEdit()">确 定</el-button>
      </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeDialog" :modal="false" class="backRgba"
                 title="重打电子面单"
                 :visible.sync="wayEditDialogVisible"
                 width="30%"
                 center>
        <el-form label-width="120px" :model="deliveryForm" :rules="rules" ref="deliveryForm" class="delivery">
          <el-form-item label="发货模式" prop="sendMode">
            <el-select v-model="deliveryForm.sendMode" placeholder="请选择发货模式" clearable @change="changeSendMode">
              <el-option label="普通模式" value="2740"></el-option>
              <el-option label="电子面单模式" value="2741"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="deliveryForm.sendMode == 2741">
            <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
              <el-select v-model="deliveryForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司"
                         @change="popularCompChange(deliveryForm.sendDeliveryCompanyId)">
                <el-option
                  style="width: 220px;"
                  v-for="item in popularcompDeliveryListData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.com_no">
                </el-option>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="子母件数量" prop="deliveryCount">-->
            <!--              <el-input size="small" v-model="deliveryForm.deliveryCount" auto-complete="off" maxLength="20" clearable></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="快递类型" prop="deliveryType">
              <el-select v-model="deliveryForm.deliveryType" placeholder="请选择快递类型" clearable>
                <el-option v-for="type in TypeDeliveryListData" :key="type.id" :label="type.name" :value="type.code">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="flex_box">
              <div class="flex_box" style="align-items: center;margin-left: 13%;">
                <p class="bfore f14 color666 mr12 w120 lh40"style="text-align: right;">打印机</p>
                <span class="f14 color333 lh40" v-if="siid">{{ siid }}</span>
                <el-button type="primary" @click="addSelectBox" plain v-else>新增打印机</el-button>
              </div>
            </div>
          </div>
          <div v-else>
            <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
              <el-select v-model="deliveryForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司" clearable
                         @change="compChange(deliveryForm.sendDeliveryCompanyId)">
                <el-option
                  v-for="item in compDeliveryListData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="快递单号" prop="sendDeliveryCode">
              <el-input size="small" v-model.trim="deliveryForm.sendDeliveryCode" auto-complete="off" maxLength="50" clearable
                        placeholder="请输入快递单号"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="waySureEdit('deliveryForm')">确 定</el-button>
          <el-button @click="closeDialog">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="!detailData.length&&isGetData" class="noData-box">
      <img src="/static/img/noData.png" alt="">
    </div>
  </div>
</template>

<script>
  import {
    sendRecord,
    updateDelivery,
    popularDeliveryList,
    eorderDeliveryList,
    printInfo,
    expressType,
    eorderPrint, listExport
  } from '../../api/basisMG'
  import {timestampToTime} from '../../utils/util'

  export default {
    data: () => {
      return {
        activeName: '0',
        loading: false, //是显示加载
        title: '添加',
        detailData: {},
        productData: [],
        id:'',
        time: '',
        code:'',
        listData: [], //用户数据
        editDialogVisible:false,
        delivery_no:'',
        send_record_id:'',
        delivery_com_id: '',
        delivery_name: '',
        isGetData:false,
        wayEditDialogVisible: false,
        popularcompDeliveryListData: [],
        compDeliveryListData: [],
        TypeDeliveryListData: [],
        siid: '',
        sendRecordId: '',
        sendId: '',
        deliveryForm: {
          sendDeliveryCode: '',
          sendDeliveryCompanyId: '',
          sendMode: '',
          deliveryCount: '',
          deliveryType: '',
          sendRecordId: '',
        },
        infoForm: {
          id: '',
          send_record_id: '',
          delivery_com_id: '',
          delivery_no: '',
          delivery_name: ''
        },
        rules: {
          sendMode: [{required: true, message: '请选择发货模式', trigger: 'change'}],
          // sendDeliveryCode: [{required: true, message: '请填写快递单号', trigger: 'blur'}],
          sendDeliveryCompanyId: [{required: true, message: '请选择快递公司', trigger: 'change'}],
          deliveryCount: [{required: true, message: '请输入子母件数量', trigger: 'change'}],
          deliveryType: [{required: true, message: '请选择快递类型', trigger: 'change'}],
        },
        infoRules: {
          delivery_no: [{required: true, message: '请填写快递单号', trigger: 'blur'}],
          delivery_name: [{required: true, message: '请选择快递公司', trigger: 'change'}],
        },
        orderId: '',
        popularDeliveryListData: [],
        comId: '',
        recordId: ''
      }
    },
    // 注册组件
    components: {},
    /**
     * 创建完毕
     */
    created() {
      this.id = this.$route.query.id;
      this.recordId = this.$route.query.send_id;
      this.time = this.$route.query.time;
      this.code = this.$route.query.code;
      if (this.$route.query.id) {
        localStorage.setItem('send_id', this.$route.query.id)
        localStorage.setItem('id', this.$route.query.recordId)
        localStorage.setItem('order_time', this.$route.query.time)
        localStorage.setItem('order_code', this.$route.query.code)
        this.getdata(this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.getdata(localStorage.getItem('send_id'))
        this.time = localStorage.getItem('order_time')
        this.code = localStorage.getItem('order_code')
        this.id = localStorage.getItem('send_id')
        this.recordId = localStorage.getItem('id')
      }
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(id) {
        this.loading = true
        sendRecord(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content;
              this.isGetData = true;
              if(res.content.length){
                this.activeName = res.content[0].id;
                this.productData = res.content.recordItems;
                this.listData = res.content.recordLogs;
                this.sendRecordId = res.content[0].id;
                this.comId = res.content[0].delivery_com_id;
              };
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '小计') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '数量') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index];
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      openEditDialog(id,delivery_no,delivery_com_id,delivery_name){
        this.delivery_no = delivery_no;
        this.delivery_name = delivery_name;
        this.delivery_com_id = delivery_com_id;
        this.send_record_id = id;
        this.editDialogVisible = true;
        this.infoForm.delivery_no = this.delivery_no;
        this.infoForm.delivery_name = this.delivery_name;
        this.infoForm.delivery_com_id = this.comId;
        let data = {
          "page": 1,
          "rows": 10,
          "name": ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.popularDeliveryListData = res.content
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
        this.getdata(this.id)
      },
      deliverChange(delivery_name) {
        this.popularDeliveryListData.forEach((item) => {
          if (item.name == delivery_name) {
            this.infoForm.delivery_com_id = item.id
          }
        })
      },
      sureEdit() {
        this.loading = true;
        this.infoForm.send_record_id = this.send_record_id;
        updateDelivery(this.infoForm)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.editDialogVisible = false;
              this.getdata(this.id)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 重打电子面单
      sendGood: function (id) {
        this.sendId = id;
        this.sendRecordId = id;
        this.orderId = id;
        this.deliveryForm = {
          deliveryCount: 1,
          sendMode: "2740",
          sendDeliveryCode: '',
          sendDeliveryCompanyId: '',
          deliveryType: '',
        };
        this.wayEditDialogVisible = true
        this.currentPage = 1;
        let compdata = {
          page: 0,
          rows: 10,
          name: ""
        }
        popularDeliveryList(compdata)
          .then(res => {
            if (res.success) {
              this.compDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 重打电子面单确定
      waySureEdit(formName) {
        let parameter = {
          orderId: this.orderId,
          sendId: this.sendId,
          sendDeliveryCompanyId: this.comnoid,
          sendDeliveryCode: this.deliveryForm.sendDeliveryCode,
          deliveryType: this.deliveryForm.deliveryType,
          sendMode: this.deliveryForm.sendMode,
          deliveryCount: this.deliveryForm.deliveryCount,
          siid: this.siid,
          sendDeliverymark: "",
          sendRecordId: this.sendRecordId,
          sendItems: []
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            eorderPrint(parameter)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功重新打印电子面单!'
                  })
                  this.wayEditDialogVisible = false;
                  this.getdata(this.id)
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 发货模式切换
      changeSendMode() {
        if (this.deliveryForm.sendMode == '2741') {
          // 电子面单快递公司
          let populardata = {
            page: 0,
            rows: 10,
            name: "",
            code: "",
          }
          eorderDeliveryList(populardata)
            .then(res => {
              if (res.success) {
                this.popularcompDeliveryListData = res.content;
              }
            })
            .catch(err => {
              this.$message.error('网络错误，请稍后再试！')
            })
          // 打印机信息
          printInfo()
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if(res.content) {
                  this.siid = res.content;
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.deliveryForm = {
          sendMode: this.deliveryForm.sendMode,
          deliveryCount: this.deliveryForm.deliveryCount,
          sendDeliveryCode: '',
          // sendDeliveryCompanyId: '',
        }
        this.$nextTick(() => {
          this.$refs["deliveryForm"].clearValidate(['sendDeliveryCode', 'deliveryType', 'sendMode', 'deliveryCount', 'sendDeliveryCompanyId']);
        });
      },
      // 电子面单模式快递公司
      popularCompChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.popularcompDeliveryListData) {
          if(this.popularcompDeliveryListData[i].com_no == sendDeliveryCompanyId) {
            this.comnoid = this.popularcompDeliveryListData[i].id
          }
        }
        this.$set(this.deliveryForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.TypeDeliveryListData = res.content;
                this.deliveryForm.deliveryType = deliveryType;
                this.deliveryForm.deliveryType = res.content[0].code;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 普通模式快递公司
      compChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.compDeliveryListData) {
          if(this.compDeliveryListData[i].id == sendDeliveryCompanyId) {
            this.comnoid = this.compDeliveryListData[i].id
          }
        }
        this.$set(this.deliveryForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.TypeDeliveryListData = res.content;
                this.deliveryForm.deliveryType = deliveryType;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.wayEditDialogVisible = false;
        this.$refs["deliveryForm"].resetFields();
      },
      // 新增打印机按钮
      addSelectBox() {
        localStorage.setItem('path', '/store/storePrinter')
        let tag = {
          url: "/store/storePrinter",
          name: "绑定打印机"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/store/storePrinter'})
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .textCenter {
    text-align: center;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .f12 {
    font-size: 12px;
  }

  .f14 {
    font-size: 14px;
  }

  .f15 {
    font-size: 15px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .item {
    margin-right: 50px;
    margin-bottom: 15px;
  }

  .item .color333 {
    margin-right: 12px;
  }

  .item p {
    display: inline-block;
  }

  .w120 {
    width: 120px;
  }

  .lh32 {
    line-height: 32px;
  }

  .lh40 {
    line-height: 40px;
  }

  .table {
    width: 1200px;
  }
  .noData-box {
    height: calc(100vh - 220px);
  }
  .noData-box img{
    width: 650px;
    height: 398px;
    margin-top: 150px;
    margin-left: 150px;
  }
  .edit {
    width: 14px;
    height: 14px;
    margin-left: 12px;
    cursor: pointer;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 15%;
  }

  .bfore :before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

</style>





// WEBPACK FOOTER //
// src/views/order/invoiceOrder.vue